import { render, staticRenderFns } from "./DSTabItem.vue?vue&type=template&id=7fb306d9&scoped=true&"
import script from "./DSTabItem.vue?vue&type=script&lang=js&"
export * from "./DSTabItem.vue?vue&type=script&lang=js&"
import style0 from "./DSTabItem.vue?vue&type=style&index=0&id=7fb306d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb306d9",
  null
  
)

export default component.exports